<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll">
            <div class="page-content reviewDetail noScroll">
                <!--  simply travel information  -->
                <div class="reviewDetail-info scroll-container">
                    <div class="reviewDetail-infoTop">
                        <div class="reviewDetail-infoTopL">
                            <img src="https://resource.rcclchina.com.cn/logo/MB/logoAvatarCircleBlueLarge.png">
                            <span>{{picDetail.nickname}}</span>
                        </div>
                        <!-- active 已点赞 -->
                        <UpVote :isUpVote="picDetail.isUpvote"
                                :score="picDetail.score"
                                :isBig="true"
                                @on-upVote="upVote"></UpVote>

                    </div>
                    <div class="reviewDetail-infoMain">
                        <div class="reviewDetail-itemOverFloat">
                            <div class="reviewDetail-itemLeft">发布时间:{{picDetail.createdDate}}</div>
                            <div class="reviewDetail-itemRight">乘坐游轮:{{picDetail.shipName}}</div>
                        </div>
                        <div class="reviewDetail-itemOverFloat">
                            <div class="reviewDetail-itemLeft">出行时间:{{picDetail.sailDate}}</div>
                            <div class="reviewDetail-itemRight">晚数:{{picDetail.sailDays}}天{{picDetail.sailDays - 1}}晚</div>
                        </div>
                        <div class="reviewDetail-itemOverFloat">
                            <div>行程:{{picDetail.cruiseName}}</div>
                        </div>
                        <div class="reviewDetail-itemTags">
                            <div v-for="(item, index) in picDetail.tags" :key="index"><span>{{item}}</span></div>
                        </div>
                    </div>
                </div>
                <!-- review content -->
                <div class="reviewDetail-content scroll-container">
                    <p>{{picDetail.content}}</p>
                    <div>
                        <img v-for="(item, index) in picDetail.imageUrls" :src="item" :key="index" alt="详情图片" style="width: 325px;" @click="showCarousel(index)">
                    </div>
                </div>

                <!-- 返回秀美图首页 -->
                <div class="review-bottom-like scroll-container">
                    <div class="reviewDetail-infoTopR js-praiseNoteBtn" v-bind:class="{active: picDetail.isUpvote}">
                        <div class="center">
                            <div class="center div--inlineBlock" @click.stop="upVote">
                                <img class="review-item-praiseIcon" src="../../assets/praiseGrayBtn-big.png" alt="未点赞图标">
                                <img class="review-item-praiseIcon" src="../../assets/review-like-big.png" alt="已点赞图标">
                            </div>
                            <span class="praiseNumber div--inlineBlock">{{picDetail.score}}</span>
                        </div>
                        <div class="center review-bottom-tips"><br></div>
                    </div>
                </div>

                <!-- 爆款推荐 -->
                <div class="shipDetail-hotCruise scroll-container" id="hotCruise">
                    <PromoCruise></PromoCruise>
                </div>

            </div>

            <router-link tag="div" class="editModel js-modelEdit" v-if="currentStatus !== 15" :to="`/Rccl.Review/ReviewPicture/UploadPicture?picId=${reviewPicId}`">
                <div>编辑</div>
            </router-link>

            <PicCarousel :isShow="isShowCarousel"
                         :imgList="picDetail.imageUrls"
                         :activeIndex='showIndex'
                         @on-close="closeCarousel"></PicCarousel>

            <Share :isActive="shareActive"
                   :status="currentStatus"
                   :shareText="shareText"
                   :shareUrl="shareUrl"
                   :shareImage="shareImage"
                   @on-goTop="goTop"></Share>

        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import wechatHelper from '@/utilities/wechatHelper'
    import UpVote from '@/components/Review/UpVote.vue'
    import PicCarousel from '@/components/Review/PicCarousel.vue'
    import Share from '@/components/Review/Share.vue'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    export default {
        name: 'ReviewDetail',
        components: {
            UpVote,
            PicCarousel,
            Share,
            PromoCruise
        },
        data () {
            return {
                userToken: '',
                picDetail: {},
                isShowCarousel: false,
                showIndex: 0,
                shareActive: false,
                currentStatus: 0,
                reviewPicId: '',
                shareText: '我刚刚在@皇家加勒比国际游轮 发现一篇#精彩秀美图# 还不赶快去看看。',
                shareUrl: '',
                shareImage: '',
                isMyPic: false
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '秀美图')
            this.showPage()
        },
        mounted () {
            if (document) {
                document.querySelector('.reviewDetail ').addEventListener('scroll', this.handleScroll, false)
                this.shareUrl = window.location.href
            }
        },
        destroyed () {
            if (document) {
                document.querySelector('.reviewDetail ').removeEventListener('scroll', this.handleScroll, false)
            }
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                const userToken = this.$store.state.user.userToken
                this.userToken = userToken
                const reviewPicId = this.$route.query.reviewPicId
                this.reviewPicId = reviewPicId
                this.picDetail = await this.getReviewDetail(reviewPicId, userToken)
                this.currentStatus = this.picDetail.status

                // 初始化微博分享
                this.shareImage = this.picDetail.imageUrls[0]
                if (wechatHelper.isWeixinBrowser()) {
                    if (this.isMyPic) {
                        this.shareText = '晒一晒我在皇家游轮上的精彩美照，等你来点赞哦~'
                    }
                    setTimeout(()=> {
                        wechatHelper.wechatShareConfig(this.picDetail.content, this.shareText
                        , location.href, 'https://resource.rcclchina.com.cn/0/QNshare.jpg');
                    }, 3000);
                }

            },
            async getReviewDetail (reviewPicId, userName) {
                const {success, data, errMsg} = await api.review.getReviewDetail({reviewPicId, userName})
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            async upVote () {
                if (!this.userToken) {
                    this.$alert.show('请先登录', {
                        confirmCallBack: ()=> {
							this.$router.push({ name: 'Login', query:{
								returnUrl: location.href
							}})
						}
                    })
                    return false
                }
                this.$loading.show()
                const {success, data, errMsg} = await api.review.upVotePic({userName: this.userToken, reviewPicId: this.picDetail.id})
                if (!success) {
                    this.$alert.show(errMsg)
                } else {
                    console.log(data)
                    this.picDetail.isUpvote = true
                    this.picDetail.score++
                }
                this.$loading.hide()
            },
            showCarousel (index) {
                this.isShowCarousel = true
                this.showIndex = index
            },
            closeCarousel () {
                this.isShowCarousel = false
            },
            handleScroll () {
                let $dom = document.querySelector('.reviewDetail ')
                let scrollTop = $dom.scrollTop
                if (scrollTop > 0) {
                    this.shareActive = true
                } else {
                    this.shareActive = false
                }
            },
            goTop () {
                let $dom = document.querySelector('.reviewDetail ')
                $dom.scrollTop = 0
            }
        }
    }
</script>

<style lang="less" scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }
    .reviewDetail {
        padding-top: 44px;
        padding-bottom: 44px;
        background-color: #e4e4e4;
        scroll-behavior: smooth;
    }
    .reviewDetail.active{
        padding-bottom:124px;
    }

    /**** simply travel information ****/
    .reviewDetail-info {
        background-color: #fff;
        padding: 0 12px;
        position: relative;
    }
    .reviewDetail-infoTop {
        width: 100%;
        overflow: hidden;
        padding: 13px 16px 11px 7px;
        border-bottom: 1px solid #d7d7d7;
    }
    .reviewDetail-infoTop .reviewDetail-infoTopL {
        float:left;
        font-size:0;
    }
    .reviewDetail-infoTop .reviewDetail-infoTopL > img {
        width:27px;
        height:27px;
        vertical-align:middle;
    }
    .reviewDetail-infoTopR.active .praiseNumber {
        color: #f6b511;
    }
    .reviewDetail-infoTop .reviewDetail-infoTopL > span {
        font-size:13px;
        color:#000;
        vertical-align:middle;
        margin-left:6px;
        font-weight:bold;
    }
    .reviewDetail-infoTopR > div img{
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
    }
    .reviewDetail-infoTopR > div img:first-child {
        display: inline-block;
    }
    .reviewDetail-infoTopR > div img:last-child {
        display: none;
    }
    .reviewDetail-infoTopR.active > div img:first-child {
        display: none;
    }
    .reviewDetail-infoTopR.active > div img:last-child {
        display: inline;
    }
    .reviewDetail-infoMain {
        margin-top:4px;
        clear:both;
        padding:13px 11px;
        border-bottom:1px solid #d7d7d7;
    }
    .reviewDetail-infoMain .reviewDetail-itemOverFloat {
        overflow:hidden;
        width:100%;
        margin-bottom:9px;
    }
    .reviewDetail-infoMain .reviewDetail-itemOverFloat > div {
        color: #000;
        font-size: 12px;
    }
    .reviewDetail-infoMain .reviewDetail-itemLeft {
        float: left;
        width: 57%;
        text-align: left;
    }
    .reviewDetail-infoMain .reviewDetail-itemRight {
        float: right;
        width: 43%;
        text-align: left;
    }
    .reviewDetail-itemTags > div {
        display: inline-block;
        margin-bottom: 4px;
        margin-right: 9px;
    }
    .reviewDetail-itemTags > div > span {
        border: 1px solid #338fb3;
        border-radius: 4px;
        padding: 1px 5px;
        color: #338fb3;
        font-size: 12px;
    }

    /**** review content ****/
    .reviewDetail-content {
        clear: both;
        padding: 13px 22px;
        background-color:#fff;
    }
    .reviewDetail-content>p{
        font-size:12px;
        color:#061556;
    }
    .reviewDetail-content>div{
        text-align:center;
    }
    .reviewDetail-content>div img{
        margin-bottom:8px;
    }

    /**** edit Model ****/
    .editModel{
        position:fixed;
        bottom:44px;
        left:0;
        width:100%;
        z-index:11;
    }
    .editModel>div{
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background-color: #f7b611;
        font-size: 12.5px;
        color: #fff;
        border: none;
        margin:0 auto;
    }

    /**** 爆款推荐 ****/
    .shipDetail-hotCruise {
        background-color: #fff;
        margin-top:19px;
    }
    .shipDetail-hotCruise .shipDetail-hotCruise-title {
        padding: 27px 0;
        position: relative;
    }
    .shipDetail-hotCruise .shipDetail-hotCruise-titleLine {
        height: 1px;
        background-color: #fecc46;
    }
    .shipDetail-hotCruise .shipDetail-hotCruise-titleTxt {
        width: 158px;
        position: absolute;
        top: 18px;
        left: 50%;
        margin-left: -79px;
        padding: 0 1.867%;
        background-color: #fff;
        text-align: center;
        color: #061556;
        font-size: 13px;
    }
    .shipDetail-hotCruise .shipDetail-hotCruise-titleTxt {
        width: 80px;
        margin-left: -40px;
    }

    .shipDetail-hotCruise .hotCruise-container {
        overflow: hidden;
    }

    .shipDetail-hotCruise .hotCruise-item {
        float: left;
        width: 49.358%;
        position: relative;
        margin-bottom: 2.282%;
    }
    .shipDetail-hotCruise .hotCruise-item:nth-child(2n+1) {
        margin-right: 1.141%;
    }
    .shipDetail-hotCruise .hotCruise-itemPic {
        width: 100%;
        height: 103px;
        overflow: hidden;
    }
    .shipDetail-hotCruise .hotCruise-itemPic img {
        display: block;
        position: relative;
        width: 100%;
        /* left: -18%; */
        top: -50%;
    }
    .shipDetail-hotCruise .hotCruise-itemTxt {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        padding-top: 3%;
        background-color: rgba(0,0,0,.4);
    }
    .hotCruise-itemTxt-cruiseName {
        height: 14.4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .shipDetail-hotCruise .hotCruise-itemTxt p {
        margin-bottom: 0;
        margin-top:-1px;
        font-size: 12px;
        color: #fff;
        -webkit-transform: scale(.9);
        -moz-transform: scale(.9);
        transform: scale(.9);
        -o-transform: scale(.9);
    }
    .shipDetail-hotCruise .hotCruise-price span {
        font-size: 14px !important;
    }
    .shipDetail-hotCruise .hotCruise-itemBtn {
        position: absolute;
        bottom: 0;
        width: 100%;
        text-align: center;
        background-color: #f0af11;
    }
    .shipDetail-hotCruise .hotCruise-itemBtn a {
        color: #000d57;
        font-size: 13px;
        display: inline-block;
        width: 100%;
    }
    .shipDetail-hotCruise .hotCruise-itemTag {
        position: absolute;
        top: 0;
        right: 4px;
        width: 30.856%;
    }
    .shipDetail-hotCruise .hotCruise-itemTag img {
        width: 100%;
    }
    .shipDetail-hotCruise .hotCruise-itemTagTxt {
        position: absolute;
        top: -3px;
        width: 100%;
        color: #fff;
        font-size: 13px;
        -webkit-transform: scale(.6);
        -moz-transform: scale(.6);
        transform: scale(.6);
        -o-transform: scale(.6);
        text-align: center;
    }
    .hotCruise-item .hold-link {
        width:100%;
        height:100%;
        position:absolute;
        left:0;
        top:0;
    }

    /**** 返回秀美图首页 ****/
    .reviewDetail-returnLists {
        padding:16px 12px;
        background-color:#fff;
    }
    .reviewDetail-returnLists>a{
        display: block;
        width: 100%;
        text-align: center;
        height: 50px;
        background-color: #f6b511;
        color: #fff;
        font-size: 14px;
        padding-top: 4px;
    }

    .review-bottom-like {
        background-color: white;
    }

    .review-bottom-like .praiseNumber {
        font-size: 20px;
    }

    .review-bottom-tips {
        margin-top: 10px;
    }

    .review-bottom-like .reviewDetail-infoTopR > div img {
        width: 40px;
        height: 40px;
    }

    .center {
        text-align: center;
    }
</style>
